import styled from "@emotion/styled";

export const Heading = styled.div`
  font-size: 72px;
  font-feature-settings: "ss01";
  line-height: 50px;
  letter-spacing: 0.5em;
  text-align: left;
`;

export const Column = styled.p`
  font-size: 14px;
  font-style: normal;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  a {
    font-weight: 500;
  }
`;

export const Index = styled.a`
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 50px;
  letter-spacing: 0.5em;
  text-align: center;

  &:active {
    color: ${(props) => props.theme.colors.primary.base};
  }
`;
